// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6ef777b7","952":"764e5ef5"}[chunkId] + ".chunk.js";
};